/* =============================================
   PRODUCT PAGE — IQONE
   2026-06-10: usunięto martwy kod prototypu (PRODUCTS database,
   product.html?id= — nigdy nie wykonywał się w motywie Liquid).
   Dodano: Klaviyo Back in Stock — przejęcie formularza "Powiadom mnie".
   ============================================= */

/* ===== KLAVIYO BACK IN STOCK =====
   Przejmuje formularz "Powiadom mnie" (#notify-cta-section) i zapisuje
   subskrypcję w Klaviyo (metryka "Subscribed to Back in Stock" →
   trigger flow "Powrót do stanu magazynowego - Standard").
   Fallback: jeśli zapis do Klaviyo się nie powiedzie, formularz wysyła
   klasyczny mail przez Shopify contact form na adres sklepu. */
(function () {
    'use strict';

    var KLAVIYO_COMPANY_ID = 'TG6UFS';
    var KLAVIYO_REVISION = '2024-10-15';

    function getSelectedVariantId() {
        var input = document.getElementById('selected-variant-id') ||
                    document.querySelector('#add-to-cart-form input[name="id"]');
        return input ? input.value : null;
    }

    function showSuccess(form) {
        form.innerHTML = '<div style="padding:14px; background:rgba(0,212,255,0.1); border-radius:8px; color:var(--cyan, #00d4ff);">✓ Dziękujemy! Damy Ci znać mailem, gdy ten rozmiar wróci na stan.</div>';
    }

    function init() {
        var wrap = document.getElementById('notify-cta-section');
        if (!wrap) return;
        var form = wrap.querySelector('form');
        if (!form) return;
        var emailInput = form.querySelector('input[type="email"]');
        var submitBtn = form.querySelector('button[type="submit"]');
        if (!emailInput || !submitBtn) return;

        var fallbackToEmail = false;

        form.addEventListener('submit', function (e) {
            if (fallbackToEmail) return; // przepuść natywny submit (mail na kontakt@)
            e.preventDefault();

            var email = (emailInput.value || '').trim();
            if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
                emailInput.style.borderColor = '#ff6b6b';
                emailInput.focus();
                return;
            }
            emailInput.style.borderColor = '';

            var variantId = getSelectedVariantId();
            if (!variantId) {
                fallbackToEmail = true;
                form.submit();
                return;
            }

            var oldLabel = submitBtn.textContent;
            submitBtn.disabled = true;
            submitBtn.textContent = 'Zapisuję...';

            fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'revision': KLAVIYO_REVISION
                },
                body: JSON.stringify({
                    data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                            profile: { data: { type: 'profile', attributes: { email: email } } },
                            channels: ['EMAIL']
                        },
                        relationships: {
                            variant: {
                                data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
                            }
                        }
                    }
                })
            }).then(function (r) {
                if (r.ok) {
                    showSuccess(form);
                } else {
                    // Klaviyo odrzucił — fallback: klasyczny mail przez contact form
                    fallbackToEmail = true;
                    submitBtn.disabled = false;
                    submitBtn.textContent = oldLabel;
                    form.submit();
                }
            }).catch(function () {
                fallbackToEmail = true;
                submitBtn.disabled = false;
                submitBtn.textContent = oldLabel;
                form.submit();
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
